import createDataProvider from '@refinedev/graphql';
import camelcase from "camelcase";
import { singular } from "pluralize";
export const API_URL = import.meta.env.VITE_GRAPHQL_URL
 
import { Client, fetchExchange, OperationResult } from "@urql/core";
import { CreateParams, DeleteOneParams, UpdateParams } from "@refinedev/core";
 
 
export const gqlClient = new Client({ url: API_URL, fetchOptions:{credentials:"include"}, exchanges: [fetchExchange] });
 
 export const dataProvider = createDataProvider(gqlClient, {

     update: {
     dataMapper: (response: OperationResult<any>, params: UpdateParams<any>) => {
       const key = `update${camelcase(singular(params.resource), {
         pascalCase: true,
       })}`;

       return response.data?.[key];
     },
     buildVariables: (params: UpdateParams<any>) => {
       return {
   
           id: params.id,
           input: params.variables,
           ...params.meta?.gqlVariables,
       
       };
     },
   },

 
 deleteOne: {
     dataMapper: (
       response: OperationResult<any>,
       params: DeleteOneParams<any>,
     ) => {
       const pascalResource = camelcase(singular(params.resource), {
         pascalCase: true,
       });

       const key = `delete${pascalResource}`;

       return response.data?.[key];
     },
     buildVariables: (params: DeleteOneParams<any>) => {
       return {
         id: params.id,
         ...params?.meta?.gqlVariables,
       };
     },
   },

    


 create:{
     
     dataMapper: (response: OperationResult<any>, params: CreateParams<any>) => {
       const key = `create${camelcase(singular(params.resource), {
         pascalCase: true,
       })}`;

       return response.data?.[key];
     },
      
     buildVariables: (params: CreateParams<any>) => {
       return {
         input: params.variables ?? params?.meta?.gqlVariables,
       };
     }}});

